import apiUrl from "./config/config";
import axios from "axios";

class roleApi {

  //Get all units
  static async getRoles(params = {})
  {

    try
    {

      const response = await axios(apiUrl + "role", { params });

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }

}

export default roleApi;
